import api from './axios';

export const logoAPI = {
  /**
   * GET /api/admin/logo
   */
  getCurrent: () => api.get('/admin/logo'),

  /**
   * POST /api/admin/logo  (multipart/form-data)
   * @param {FormData} formData  — field name: logo
   */
  upload: (formData) =>
    api.post('/admin/logo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
};
